import React, { useState } from 'react'
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Table
} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import { fetchAllBinReport, fetchAllHeroReport } from '../../modules/reports'
import moment from 'moment'
import { groupBy, isEmpty, isNull, isUndefined, some } from 'lodash'
import { compose, graphql } from 'react-apollo'
import { GET_CATEGORY_LIST } from '../../graphql/queries'
import { DATE, ENDPOINT, HERO_TYPE ,TRANSACTION_STATUS } from '../../utils/constants'
import { ButtonEx } from '../../styles/button.style'
import Lightbox from "react-image-lightbox";
import "../../../node_modules/react-image-lightbox/style.css";


const { RangePicker } = DatePicker

const Transaction = ({ form, data }) => {
  const dispatch = useDispatch()
  const { validateFields, getFieldDecorator } = form
  const [filterOptions, setFilterOptions] = useState({
    size: 20,
    page: 0
  })
  const [categoryOption, setCategoryOption] = useState(true)
  const [typeOption, setTypeOption] = useState(true)
  const [heroOption, setHeroOption] = useState(true)
  const [brandOption, setBrandOption] = useState(true)
  const [Brand, setBrand] = useState([])
  const [activityOption, setActivityOption] = useState(true)
  const [Activity, setActivity] = useState([])
  const [heroIds, setHeroIds] = useState([])
  const [current, setCurrent] = useState('')
  const [date, setDate] = useState([moment(new Date()), moment(new Date())])

  const { transactionList, heroList, isLoading } = useSelector(
    (state) => ({
      heroList: state.reports.allHeroList,
      transactionList: state.reports.allTransactionList,
      isLoading: state.reports.isLoading
    }),
    []
  )

  async function fetchData() {
    await dispatch(fetchAllHeroReport())
    await dispatch(fetchAllBinReport(filterOptions))
  }

  useDeepEffect(() => {
    form.setFieldsValue({
      categoryId: [0],
      brand: [0],
      activities: [0],
      heroType: [0],
      heroId: [0]
    })
    fetchData()
  }, [])

  useDeepEffect(() => {
    if (!isEmpty(heroList)) {
      setHeroSelect()
      setBrandSelect()
      setActivitySelect()
    }
  }, [heroList])

  async function setHeroSelect() {
    const arr = groupBy(heroList, 'heroId')
    const results = []
    for (const item of Object.keys(arr)) {
      results.push({
        heroId: item,
        heroName: arr[item][0].heroName
      })
    }
    setHeroIds(results)
  }

  async function setBrandSelect() {
    const arr = groupBy(heroList, 'brand')
    const results = []
    for (const item of Object.keys(arr)) {
      if (item !== 'null') {
        results.push({
          brandName: item
        })
      }
    }
    setBrand(results)
  }
  async function setActivitySelect() {
    const arr = groupBy(heroList, 'activities')
    const results = []
    for (const item of Object.keys(arr)) {
      if (item !== 'null') {
        results.push({
          activityName: item
        })
      }
    }
    setActivity(results)
  }

  async function onShowSizeChange(current, pageSize) {
    filterOptions.size = pageSize
    filterOptions.page = 0
    setFilterOptions(filterOptions)
    await dispatch(fetchAllBinReport(filterOptions))
  }

  async function onChange(page) {
    filterOptions.page = page - 1
    setFilterOptions(filterOptions)
    await dispatch(fetchAllBinReport(filterOptions))
  }

  function onDateChange(date) {
    if (!isNull(date)) {
      setDate(date)
    } else {
      setDate([moment(new Date()), moment(new Date())])
    }
  }
  const handleClickImage = (e, image) => {
    e && e.preventDefault();
    setCurrent(image)
  };

  const handleCloseModal = e => {
    e && e.preventDefault();
    setCurrent('')
  };

  function handleChange(value) {
    const isAll = some(value, (item) => {
      return item === '0'
    })

    if (isAll) {
      setCategoryOption(true)
      // setCategorySelect(['all'])
      form.setFieldsValue({
        category: ['0']
      })
    } else {
      setCategoryOption(false)
      // setCategorySelect(value)
    }
  }

  function handleBrandChange(value) {
    const isAll = some(value, (item) => {
      return item === 'all'
    })
    if (isAll) {
      setBrandOption(true)
    } else {
      setBrandOption(false)
    }
  }

  function handleActivityChange(value) {
    const isAll = some(value, (item) => {
      return item === 'all'
    })
    if (isAll) {
      setActivityOption(true)
    } else {
      setActivityOption(false)
    }
  }

  function handleTypeChange(value) {
    const isAll = some(value, (item) => {
      return item === 'all'
    })

    if (isAll) {
      setTypeOption(true)
    } else {
      setTypeOption(false)
    }
  }

  function handleHeroChange(value) {
    const isAll = some(value, (item) => {
      return item === '0'
    })

    if (isAll) {
      setHeroOption(true)
    } else {
      setHeroOption(false)
    }
  }

  const columns = [
    {
      title: 'ลำดับ',
      render: (text, record, index) => (
        <span>{filterOptions.page * filterOptions.size + index + 1}</span>
      )
    },
    {
      title: 'ชื่อฮีโร่',
      dataIndex: 'heroName',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'ประเภทฮีโร่',
      dataIndex: 'heroType',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'บาร์โค้ดสินค้า',
      dataIndex: 'barcode',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'สินค้า',
      align: 'center',
      render: (text, record) => {
        return record.name && record.brand ? (
          <span>{`${record.name} ${record.brand}`}</span>
        ) : (
          '-'
        )
      }
    },
    {
      title: 'วัสดุที่ได้',
      dataIndex: 'materialName',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'แบรนด์สินค้า',
      dataIndex: 'brand',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'น้ำหนัก',
      dataIndex: 'weight',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'CO2e',
      dataIndex: 'co2e',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'รูปภาพ',
      dataIndex: 'img',
      align: 'center',
      render: (image) =>
        <span>
          {image != null ?
            <span>
              <img
                src={image}
                width={100}
                height={100}
                style={{ marginRight: 10, objectFit: 'cover' }}
                alt="img"
                onClick={e => handleClickImage(e, image)}
              />
              {current && (
                <Lightbox mainSrc={current} onCloseRequest={handleCloseModal} />
              )}
            </span>
            : '-'}
        </span>
    },
    {
      title: 'กิจกรรม',
      dataIndex: 'activities',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'ผู้ทิ้ง',
      dataIndex: 'user',
      align: 'center'
    },
    {
      title: 'วันที่ทิ้ง',
      dataIndex: 'datetime',
      align: 'center',
      render: (text, record) => {
        return moment(text).format('DD-MM-YYYY')
      }
    },
    {
      title: 'สถานะ',
      dataIndex: 'status',
      align: 'center',
      render: (status) => <span>{TRANSACTION_STATUS[status]}</span>
    }
  ]

  const onClear = async (e) => {
    e.preventDefault()
    setFilterOptions((prevState) => {
      prevState.size = 20
      prevState.page = 0
      prevState.heroId = undefined
      prevState.heroType = undefined
      prevState.category = undefined
      prevState.brand = undefined
      prevState.activities = undefined
      prevState.keyword = undefined
      return prevState
    })

    form.setFieldsValue({
      keyword: '',
      brand: [0],
      activities: [0],
      categoryId: [0],
      heroType: [0],
      heroId: [0]
    })

    await setHeroSelect()
    await setBrandSelect()
    await setActivitySelect()
    await dispatch(fetchAllBinReport(filterOptions))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        filterOptions.keyword = values.keyword || undefined

        if (values.heroId) {
          if (values.heroId[0] === 0) {
            filterOptions.heroId = undefined
          } else {
            filterOptions.heroId = !isUndefined(values.heroId)
              ? values.heroId.join()
              : undefined
          }
        }

        if (values.categoryId) {
          if (values.categoryId[0] === 0) {
            filterOptions.categoryId = undefined
          } else {
            filterOptions.categoryId = !isUndefined(values.categoryId)
              ? values.categoryId.join()
              : undefined
          }
        }

        if (values.heroType) {
          if (values.heroType[0] === 0) {
            filterOptions.heroType = undefined
          } else {
            filterOptions.heroType = !isUndefined(values.heroType)
              ? values.heroType.join()
              : undefined
          }
        }

        if (values.brand) {
          if (values.brand[0] === 0) {
            filterOptions.brand = undefined
          } else {
            filterOptions.brand = !isUndefined(values.brand)
              ? values.brand.join()
              : undefined
          }
        }

        if (values.activities) {
          if (values.activities[0] === 0) {
            filterOptions.activities = undefined
          } else {
            filterOptions.activities = !isUndefined(values.activities)
              ? values.activities.join()
              : undefined
          }
        }
        filterOptions.page = 0
        setFilterOptions(filterOptions)
        await dispatch(fetchAllBinReport(filterOptions))
      }
    })
  }

  async function onSearch(value) {
    if (value) {
      const arr = heroIds.filter((hero) => {
        return hero.heroName.toString().toLowerCase().includes(value.toString())
      })
      setHeroIds(arr)
    } else {
      await setHeroSelect()
      await setBrandSelect()
      await setActivitySelect()
    }
  }

  function getHeroIdUrl() {
    const heroId = form.getFieldValue('heroId')
    if (heroId[0] !== 0) {
      return `&heroId=${heroId.join()}`
    }
    return ''
  }

  function getHeroTypeUrl() {
    const heroType = form.getFieldValue('heroType')
    if (heroType[0] !== 0) {
      return `&heroType=${heroType.join()}`
    }
    return ''
  }
  function getBrandUrl() {
    const brand = form.getFieldValue('brand')
    if (brand[0] !== 0) {
      return `&brand=${brand.join()}`
    }
    return ''
  }
  function getActivitiesUrl() {
    const activities = form.getFieldValue('activities')
    if (activities[0] !== 0) {
      return `&activities=${activities.join()}`
    }
    return ''
  }

  function getCategoryUrl() {
    const category = form.getFieldValue('categoryId')
    if (category[0] !== 0) {
      return `&categoryId=${category.join()}`
    }
    return ''
  }

  return (
    <Row type="flex" gutter={[8, 8]}>
      <Col span={24}>
        <Row style={{ marginBottom: 15 }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Row type="flex" justify="end" gutter={8}>
              <Col>
                <RangePicker
                  value={date}
                  onChange={onDateChange}
                  format={DATE.FORMAT}
                />
              </Col>
              <Col>
                <ButtonEx color="#6ebf4b" type="primary">
                  {!isUndefined(form.getFieldValue('heroId')) ? (
                    <a
                      href={
                        ENDPOINT +
                        `/bin/export-admin-all?${getHeroIdUrl()}${getHeroTypeUrl()}${getCategoryUrl()}${getBrandUrl()}${getActivitiesUrl()}&from=${moment(
                          date[0]
                        ).format(DATE.FORMAT)}&to=${moment(date[1]).format(
                          DATE.FORMAT
                        )}`
                      }
                      download>
                      Export Data
                    </a>
                  ) : (
                    <span>Select Hero</span>
                  )}
                </ButtonEx>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Card>
          <Form
            form={form}
            layout="vertical"
            colon={false}
            onSubmit={handleSubmit}>
            <Row gutter={8}>
              <Col span={18}>
                <Row gutter={8}>
                  <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <Form.Item label="ค้นหาข้อมูลการทิ้งขยะ">
                      {getFieldDecorator('keyword')(
                        <Input placeholder="บาร์โค้ด ชื่อสินค้า ยี่ห้อสินค้า" />
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <Form.Item label="ฮีโร่">
                      {getFieldDecorator('heroId')(
                        <Select
                          allowClear={true}
                          mode="multiple"
                          showSearch={true}
                          onChange={handleHeroChange}
                          onSearch={onSearch}
                          showArrow={true}
                          filterOption={false}
                          notFoundContent={null}>
                          <Select.Option value={0}>ทั้งหมด</Select.Option>
                          {heroIds.map((hero, index) => {
                            return (
                              <Select.Option
                                key={index}
                                value={hero.heroId}
                                disabled={heroOption}>
                                {hero.heroName}
                              </Select.Option>
                            )
                          })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <Form.Item label="ประเภทฮีโร่">
                      {getFieldDecorator('heroType')(
                        <Select
                          mode="multiple"
                          onChange={handleTypeChange}
                          showArrow={true}>
                          <Select.Option value={0}>ทั้งหมด</Select.Option>
                          {HERO_TYPE.map((type, index) => {
                            return (
                              <Select.Option
                                key={index}
                                value={type}
                                disabled={typeOption}>
                                {type}
                              </Select.Option>
                            )
                          })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <Form.Item label="หมวดของวัสดุ">
                      {getFieldDecorator('categoryId')(
                        <Select
                          mode="multiple"
                          onChange={handleChange}
                          showArrow={true}>
                          <Select.Option value={0}>ทั้งหมด</Select.Option>
                          {data.categories &&
                            data.categories.map((category, index) => {
                              return (
                                <Select.Option
                                  key={index}
                                  value={category.id}
                                  disabled={categoryOption}>
                                  {category.name}
                                </Select.Option>
                              )
                            })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <Form.Item label="แบรนด์สินค้า">
                      {getFieldDecorator('brand')(
                        <Select
                          allowClear={true}
                          mode="multiple"
                          showSearch={true}
                          onChange={handleBrandChange}
                          onSearch={onSearch}
                          showArrow={true}
                          filterOption={false}
                          notFoundContent={null}>
                          <Select.Option value={0}>ทั้งหมด</Select.Option>
                          {Brand.map((brand, index) => {
                            return (
                              <Select.Option
                                key={index}
                                value={brand.brandName}
                                disabled={brandOption}>
                                {brand.brandName}
                              </Select.Option>
                            )
                          })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <Form.Item label="กิจกรรม">
                      {getFieldDecorator('activities')(
                        <Select
                          allowClear={true}
                          mode="multiple"
                          showSearch={true}
                          onChange={handleActivityChange}
                          onSearch={onSearch}
                          showArrow={true}
                          filterOption={false}
                          notFoundContent={null}>
                          <Select.Option value={0}>ทั้งหมด</Select.Option>
                          {Activity.map((activities, index) => {
                            return (
                              <Select.Option
                                key={index}
                                value={activities.activityName}
                                disabled={activityOption}>
                                {activities.activityName}
                              </Select.Option>
                            )
                          })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <Form.Item label="" style={{ marginTop: '1.75rem' }}>
                      <Row gutter={8} type="flex">
                        <Col>
                          <Button type="primary" htmlType="submit">
                            ค้นหา
                          </Button>
                        </Col>
                        <Col>
                          <Button type="danger" onClick={(e) => onClear(e)}>
                            เคลียร์
                          </Button>
                        </Col>
                      </Row>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </Card>
      </Col>
      <Col span={24}>
        <Table
          scroll={{ x: 2300 }}
          rowKey={(record) => {
            return record.id
          }}
          bordered
          dataSource={transactionList.content}
          columns={columns}
          loading={isLoading}
          pagination={{
            current: !isEmpty(transactionList)
              ? transactionList.pageable.pageNumber + 1
              : 1,
            pageSize: transactionList.size,
            pageSizeOptions: ['10', '20', '50', '100'],
            showSizeChanger: true,
            onShowSizeChange: onShowSizeChange,
            onChange: onChange,
            total: transactionList.totalElements
          }}
        />
      </Col>
    </Row>
  )
}

const WrappedTransaction = Form.create({
  name: 'WrappedTransaction'
})(Transaction)

export default compose(graphql(GET_CATEGORY_LIST))(WrappedTransaction)



// WEBPACK FOOTER //
// ./src/pages/Transaction/index.js